import React from 'react';
import PropTypes from 'prop-types';

import SelectionBox from './SelectionBox';
import { getSelectableRowKeys } from './utils';

class SelectionHeaderCell extends React.PureComponent {
  constructor(props) {
    super(props);

    this._handleChange = this._handleChange.bind(this);
  }

  _getSelectionState() {
    const { data, rowKey, selectable, selectedRowKeys } = this.props;
    const selectableRowKeys = getSelectableRowKeys(data, selectable, rowKey);
    const checked = selectedRowKeys.length > 0;
    const partialChecked = checked && selectedRowKeys.length < selectableRowKeys.length;

    return { selectableRowKeys, checked, partialChecked };
  }

  render() {
    const { checked, partialChecked } = this._getSelectionState();

    return (
      <SelectionBox
        checked={checked}
        indeterminate={partialChecked}
        onChange={this._handleChange}
      />
    );
  }

  _handleChange() {
    const { selectableRowKeys, checked, partialChecked } = this._getSelectionState();

    const needClear = checked && !partialChecked;
    const selectedRowKeys = needClear ? [] : selectableRowKeys;

    this.props.onChange(!needClear, selectedRowKeys);
  }
}

SelectionHeaderCell.propTypes = {
  data: PropTypes.arrayOf(PropTypes.object),
  rowKey: PropTypes.string,
  selectable: PropTypes.oneOfType([PropTypes.bool, PropTypes.func]),
  selectedRowKeys: PropTypes.arrayOf(PropTypes.string),
  onChange: PropTypes.func
};

export default SelectionHeaderCell;
